export default "__VITE_PUBLIC_ASSET__3c86d63f__"